import CarResultCard from '../components/results/CarResultCard';
import SearchResultsLayout from '../components/SearchResultsLayout';
import { SEARCH_BANNERS } from '../data/mockData';

export default function CarResultsPage() {
  return (
    <SearchResultsLayout
      type="cars"
      bannerImage={SEARCH_BANNERS.cars}
      title="Car Rental Results"
      summary={(sp) =>
        `${sp.get('pickup') || 'Pick-up'} · ${sp.get('pickupDate') || '—'} – ${sp.get('dropoffDate') || '—'}`
      }
      renderCard={(item, searchParams) => (
        <CarResultCard key={item.id} item={item} searchParams={searchParams} />
      )}
    />
  );
}
